/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2021, Zumper
 */

import ContentLoader from 'react-content-loader'

// TODO take colors from a theme
export interface DotsProps {
  /** Background color of the Dot */
  backgroundColor?: string
  /** Color of the foreground animation */
  foregroundColor?: string
  /** In pixels (width will be adjusted automatically) */
  height?: number
  /** Between dots */
  separation?: number
  /** Duration of the animation in seconds */
  speed?: number
}

/**
 * Renders 3 circles with an animation.
 */
export const Dots = ({
  backgroundColor = '#726F6C',
  foregroundColor = '#d5d4d3',
  height = 4,
  separation = height / 1.5,
  speed = 1,
}: DotsProps) => {
  const radius = height / 2
  const width = height * 3 + separation * 2
  const uniqueKey = `dots${height}${backgroundColor}${foregroundColor}`
  return (
    <ContentLoader
      backgroundColor={backgroundColor}
      foregroundColor={foregroundColor}
      height={height}
      speed={speed}
      uniqueKey={uniqueKey}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
    >
      <circle cx={radius} cy={radius} r={radius} />
      <circle cx={height + separation + radius} cy={radius} r={radius} />
      <circle cx={2 * (height + separation) + radius} cy={radius} r={radius} />
    </ContentLoader>
  )
}
